import { render, staticRenderFns } from "./referafriend-popup.vue?vue&type=template&id=be266ee0&scoped=true&"
import script from "./referafriend-popup.vue?vue&type=script&lang=js&"
export * from "./referafriend-popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be266ee0",
  null
  
)

export default component.exports